module.exports = __webpack_public_path__ + "img/Group 427320599.86e66963.png";